import { render } from "./AddMediaPress.vue?vue&type=template&id=3d278195&scoped=true"
import script from "./AddMediaPress.vue?vue&type=script&lang=js"
export * from "./AddMediaPress.vue?vue&type=script&lang=js"

import "./AddMediaPress.vue?vue&type=style&index=0&id=3d278195&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d278195"]])

export default __exports__